export default __webpack_public_path__ + "static/media/upload.8a81a6c6.svg";